import React from 'react'
import PropTypes from 'prop-types'

import grid from '../assets/images/nav-grid.jpg'
import arrowBack from '../assets/images/nav-previous.jpg'
import arrowNext from '../assets/images/nav-next.jpg'

export default class SlideshowFooter extends React.Component {

    static propTypes = {
        branding: PropTypes.bool,
        vr: PropTypes.bool,
        prev: PropTypes.string,
        next: PropTypes.string,
    }

    static defaultProps = {
        className: 'full-page-controls',
        branding: false,
        vr: false,
        prev: null,
        next: null,
        data: require('../data/index'),
    }

    render() {

        const { branding, prev, next } = this.props;
        const urlBack = branding ? '/' : '/digital-realities';

        return(
            <div className="full-page-footer show">
                <ul className="icons">
                    <li>
                        <a href={prev} className="icon">
                            <img src={arrowBack} alt=""/>
                        </a>
                    </li>
                    <li>
                        <a href={urlBack} className="icon">
                            <img src={grid} alt=""/>
                        </a>
                    </li>
                    <li>
                        <a href={next} className="icon">
                            <img src={arrowNext} alt=""/>
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/SlideshowFooter.js